import * as React from 'react';

function SvgShieldCheckSolid(props) {
  return (
    <svg width={46} height={46} fill="none" viewBox="0 0 46 46" {...props}>
      <g clipPath="url(#shield-check-solid_svg__clip0)">
        <path
          fill="#24CC85"
          d="M41.9121 7.5208L24.6621 0.333302C24.2241 0.150829 23.4798 0.000610352 23.0054 0.000610352C22.5281 0.000610352 21.788 0.150829 21.3469 0.333302L4.09777 7.5208C2.48867 8.18475 1.4375 9.75701 1.4375 11.4191C1.4375 34.6078 18.4359 46 22.991 46C27.591 46 44.5625 34.482 44.5625 11.4191C44.5625 9.75701 43.5113 8.18475 41.9121 7.5208ZM31.625 17.9687C31.625 18.4657 31.4542 18.9651 31.1056 19.3721L22.4806 29.4346C21.877 30.1426 21.0773 30.1066 20.8438 30.1066C20.2738 30.1066 19.7234 29.8792 19.3191 29.4749L15.0066 25.1624C14.5816 24.8238 14.375 24.2668 14.375 23.6379C14.375 22.4888 15.3004 21.4816 16.5312 21.4816C17.083 21.4816 17.6345 21.6922 18.0559 22.1133L20.7234 24.7808L27.8327 16.4846C28.2603 15.9876 28.8641 15.7333 29.4714 15.7333C31.1219 15.8125 31.625 17.3039 31.625 17.9687Z"
        />
      </g>
      <defs>
        <clipPath id="shield-check-solid_svg__clip0">
          <path fill="#fff" d="M0 0H46V46H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgShieldCheckSolid;
